import { startPreloading, stopPreloading } from "./Preloading"
import { showStatusmessage } from "./Statusmessage"
import translations from "./translations"
import { fetchXhr } from "./fetchHelpers"
import { getLanguage } from "./i18n"

export default function CustomRemote(node) {
  node.addEventListener("click", async (e) => {
    e.preventDefault()

    const href = node.getAttribute("data-href")
    if (!href) return

    startPreloading()

    const method = node.getAttribute("data-method") || "GET"

    const { error, data } = await fetchXhr(href, { method })

    stopPreloading()

    if (error) {
      showStatusmessage(translations[getLanguage()].errors.default, "error")
      return
    }

    eval(data)
    if (method.toUpperCase() === "GET") window._gaq?.push(["_trackPageview", href])
  })
}
